module.exports = __webpack_public_path__ + "img/product6.e48b2ddb.jpg";